import React from "react";
import SportCode from "components/common/SportCode"
import { findArray } from 'helpers/utils'
import {
    isFinishedStatus,
    isLiveStatus,
    RESULT_STATUS,
    getResultStatusAsInteger,
} from "helpers/status";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faFutbol } from "@fortawesome/free-solid-svg-icons";
import Label from "components/general/Label";
import { useViewport } from 'components/general/useViewPort';
import Flag from "components/presentation/Flag";
import Competitor from 'components/presentation/Competitor';



const TeqScoreboard = ({ data, status, mirs_discipline }) => {
    const { breakPoint } = useViewport()
    let scoreboard
    let resultStatus = status

    let home = findArray(data?.results?.items, { startSortOrder: [1] });
    let homeNoc = home?.participant?.organisation?.code;
    let homeSeedValue = findArray(home?.eventUnitEntries, { eue_code: ['SEED'] }).eue_value
    let homeSeed = homeSeedValue ? '(' + homeSeedValue + ')' : ''
    let homeResult = home?.resultData;
    let homeWinner = home?.resultWLT;
    let homeIrm = home?.resultIrm;
    let homeColourTeam = findArray(home?.eventUnitEntries, { eue_code: ['UNIFORM', 'COLOUR'] }).eue_value?.toLowerCase();

    let away = findArray(data?.results?.items, { startSortOrder: [2] });
    let awayNoc = away?.participant?.organisation?.code;
    let awaySeedValue = findArray(away?.eventUnitEntries, { eue_code: ['SEED'] }).eue_value
    let awaySeed = awaySeedValue ? '(' + awaySeedValue + ')' : ''
    let awayResult = away?.resultData;
    let awayWinner = away?.resultWLT;
    let awayIrm = away?.resultIrm;
    let awayColourTeam = findArray(away?.eventUnitEntries, { eue_code: ['UNIFORM', 'COLOUR'] }).eue_value?.toLowerCase()

    let s1 = findArray(data?.results?.periods, { p_code: ['S1'] })
    let s2 = findArray(data?.results?.periods, { p_code: ['S2'] })
    let s3 = findArray(data?.results?.periods, { p_code: ['S3'] })

    let isDoubles = home?.itemType === 'T' ? true : false
    let homeCompetitorCode = home?.itemType === 'T' ? home?.teamCode : home?.athleteCode;
    let awayCompetitorCode = away?.itemType === 'T' ? away?.teamCode : away?.athleteCode;
    let homeName = home?.participant?.name ? home?.participant?.name : <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={homeCompetitorCode} />
    let awayName = away?.participant?.name ? away?.participant?.name : <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={awayCompetitorCode} />


    let currentPeriod = findArray(data?.results?.extendedInfos, { ei_code: ['CURRENT_SET'] }).ei_value
    let totalDuration = findArray(data?.results?.extendedInfos, { ei_code: ['DURATION_PLAYING'] }).ei_value
    let currentServe = findArray(data?.results?.extendedInfos, { ei_code: ['SERVE'] }).ei_value

    let officialLabelHomeCheck
    let officialLabelAwayCheck

    if (isFinishedStatus(resultStatus)) {
        if (homeWinner.includes("W")) {
            officialLabelHomeCheck = <FontAwesomeIcon icon={faCheck} />
        }
        else if (awayWinner.includes("W")) {
            officialLabelAwayCheck = <FontAwesomeIcon icon={faCheck} />
        }

        if (homeIrm)
            officialLabelHomeCheck = <strong>{homeIrm}</strong>
        if (awayIrm)
            officialLabelHomeCheck = <strong>{awayIrm}</strong>
    }


    scoreboard = (
        <>
            <table className="table">
                <thead>
                    <tr>
                        <th colSpan="3" width="50%"></th>
                        <th scope="col" className="text-center">
                            <Label data='HeaderSets' /></th>
                        {currentPeriod === 'S1' && isLiveStatus(resultStatus)
                            ? <th scope="col" className=" text-center score-current">
                                <ResponsiveHeaders mirs_discipline={mirs_discipline} entity='@Period' code='S1' /></th>
                            : <th scope="col" className=" text-center ">
                                <ResponsiveHeaders mirs_discipline={mirs_discipline} entity='@Period' code='S1' /></th>
                        }

                        {currentPeriod === 'S2' && isLiveStatus(resultStatus)
                            ? <th scope="col" className=" text-center score-current">
                                <ResponsiveHeaders mirs_discipline={mirs_discipline} entity='@Period' code='S2' /></th>
                            : <th scope="col" className=" text-center">
                                <ResponsiveHeaders mirs_discipline={mirs_discipline} entity='@Period' code='S2' /></th>
                        }
                        {currentPeriod === 'S3' && isLiveStatus(resultStatus)
                            ? <th scope="col" className=" text-center score-current">
                                <ResponsiveHeaders mirs_discipline={mirs_discipline} entity='@Period' code='S3' /></th>
                            : <th scope="col" className=" text-center ">
                                <ResponsiveHeaders mirs_discipline={mirs_discipline} entity='@Period' code='S3' /></th>
                        }

                    </tr>
                </thead>
                <tbody>
                    <tr style={{ height: "80px" }}>
                        <td className="text-start">
                            <div className={`score-horizontal-uniform score-horizontal-uniform-home ${homeColourTeam ? 'uniform-color-' + homeColourTeam : 'uniform-color-silver'} `}></div>
                            <div className='score-horizontal-team score-horizontal-team-home'>
                                <div className={`score-horizontal-uniform-small ${homeColourTeam ? 'uniform-color-' + homeColourTeam : 'uniform-color-silver'} `}></div>
                                <div className='score-horizontal-noc-flag-name'>
                                    <div className='score-horizontal-noc-flag'>
                                        <div className='score-horizontal-code-home'>
                                            <div className='score-horizontal-code-noc'>{homeNoc}</div>
                                        </div>
                                        <Flag noc={homeNoc} className='score-horizontal-flag-home' />
                                    </div>

                                    <div className='score-horizontal-name score-horizontal-name-home d-none d-md-block'>
                                        {isDoubles
                                            ? <> <strong><Competitor hidePicture={true} hideNoc={true} teamAthletes={home?.teamAthletes} /></strong></>
                                            : <><strong>{homeName}</strong><sup>{homeSeed}</sup></>
                                        }
                                    </div>
                                    <div className='score-horizontal-name score-horizontal-name-home d-block d-md-none'>
                                        {isDoubles
                                            ? <> <strong><Competitor hidePicture={true} hideNoc={true} teamAthletes={home?.teamAthletes} /></strong></>
                                            : <> <strong>{home?.participant?.shortName}</strong><sup>{homeSeed}</sup></>
                                        }
                                    </div>
                                </div>
                            </div>
                        </td>

                        {breakPoint === "sm" || breakPoint === "xs"
                            ? <>
                                <td>
                                    <div className="d-flex align-items-center justify-content-center">
                                        {officialLabelHomeCheck}
                                    </div>
                                </td>
                                <td>
                                    <div className="d-flex align-items-center">
                                        {currentServe === 'H'
                                            ? <FontAwesomeIcon icon={faFutbol} />
                                            : ''
                                        }
                                    </div>
                                </td>
                            </>
                            : <>
                                <td>
                                    <div className="d-flex align-items-center">
                                        {officialLabelHomeCheck}
                                    </div>
                                </td>
                                <td>
                                    <div className="d-flex align-items-center">
                                        {currentServe === 'H'
                                            ? <FontAwesomeIcon icon={faFutbol} />
                                            : ''
                                        }
                                    </div>
                                </td>
                            </>
                        }

                        <td className="text-center align-middle" >
                            <div className='score-horizontal-result-number'>
                                <strong>{homeResult}</strong>
                            </div>
                        </td>
                        {currentPeriod === 'S1' && isLiveStatus(resultStatus)
                            ? <td className="text-center align-middle score-current">{s1?.home?.periodScore}</td>
                            : <td className="text-center align-middle">{s1?.home?.periodScore}</td>
                        }

                        {currentPeriod === 'S2' && isLiveStatus(resultStatus)
                            ? <td className="text-center align-middle score-current">{s2?.home?.periodScore}</td>
                            : <td className="text-center align-middle">{s2?.home?.periodScore}</td>
                        }

                        {currentPeriod === 'S3' && isLiveStatus(resultStatus)
                            ? <td className="text-center align-middle  score-current">{s3?.home?.periodScore}</td>
                            : <td className="text-center align-middle">{s3?.home?.periodScore}</td>
                        }

                    </tr>

                    <tr style={{ height: "80px" }}>
                        <td>
                            <div className={`score-horizontal-uniform score-vertical-uniform-away ${awayColourTeam ? 'uniform-color-' + awayColourTeam : 'uniform-color-silver'} `}></div>
                            <div className='score-horizontal-team score-horizontal-team-home'>
                                <div className={`score-horizontal-uniform-small ${awayColourTeam ? 'uniform-color-' + awayColourTeam : 'uniform-color-silver'} `}></div>
                                <div className='score-horizontal-noc-flag-name'>
                                    <div className='score-horizontal-noc-flag'>
                                        <div className='score-horizontal-code-home'>
                                            <div className='score-horizontal-code-noc'>{awayNoc}</div>
                                        </div>
                                        <Flag noc={awayNoc} className='score-horizontal-flag-home' />
                                    </div>
                                    <div className='score-horizontal-name score-horizontal-name-home d-none d-md-block'>
                                        {isDoubles
                                            ? <> <strong><Competitor hidePicture={true} hideNoc={true} teamAthletes={away?.teamAthletes} /></strong></>
                                            : <><strong>{awayName}</strong><sup>{awaySeed}</sup></>
                                        }
                                    </div>
                                    <div className='score-horizontal-name score-horizontal-name-home d-block d-md-none'>
                                        {isDoubles
                                            ? <> <strong><Competitor hidePicture={true} hideNoc={true} teamAthletes={away?.teamAthletes} /></strong></>
                                            : <> <strong>{away?.participant?.shortName}</strong><sup>{awaySeed}</sup></>
                                        }
                                    </div>
                                </div>
                            </div>
                        </td>

                        {breakPoint === "sm" || breakPoint === "xs"
                            ? <>
                                <td>
                                    <div className="d-flex align-items-center justify-content-center">
                                        {officialLabelAwayCheck}
                                    </div>
                                </td>
                                <td>
                                    <div className="d-flex align-items-center">
                                        {currentServe === 'A'
                                            ? <FontAwesomeIcon icon={faFutbol} />
                                            : ''
                                        }
                                    </div>
                                </td>
                            </>
                            : <>
                                <td>
                                    <div className="d-flex align-items-center">
                                        {officialLabelAwayCheck}
                                    </div>
                                </td>
                                <td>
                                    <div className="d-flex align-items-center">
                                        {currentServe === 'A'
                                            ? <FontAwesomeIcon icon={faFutbol} />
                                            : ''
                                        }
                                    </div>
                                </td>

                            </>
                        }

                        <td className="text-center align-middle" >
                            <div className='score-horizontal-result-number'>
                                <strong>{awayResult}</strong>
                            </div>
                        </td>
                        {currentPeriod === 'S1' && isLiveStatus(resultStatus)
                            ? <td className="text-center align-middle score-current">{s1?.away?.periodScore}</td>
                            : <td className="text-center align-middle">{s1?.away?.periodScore}</td>
                        }

                        {currentPeriod === 'S2' && isLiveStatus(resultStatus)
                            ? <td className="text-center align-middle score-current">{s2?.away?.periodScore}</td>
                            : <td className="text-center align-middle">{s2?.away?.periodScore}</td>
                        }

                        {currentPeriod === 'S3' && isLiveStatus(resultStatus)
                            ? <td className="text-center align-middle  score-current">{s3?.away?.periodScore}</td>
                            : <td className="text-center align-middle">{s3?.away?.periodScore}</td>
                        }

                    </tr>

                    {getResultStatusAsInteger(resultStatus) === RESULT_STATUS.START_LIST
                        ? <></>
                        : <tr style={{ height: "20px" }}>

                            {breakPoint === "sm" || breakPoint === "xs"
                                ? <td className="text-end align-middle" colSpan="3"><Label data='HeaderPlayingTime' />&nbsp;(<Label data='LabelMinuteShort' />):</td>
                                : <td className="text-end align-middle" colSpan="3"><Label data='HeaderPlayingTime' />:</td>
                            }

                            {breakPoint === "sm" || breakPoint === "xs"
                                ? <>
                                    <td className="text-center align-middle">{totalDuration}</td>
                                    <td className="text-center align-middle">{s1?.p_duration}</td>
                                    <td className="text-center align-middle">{s2?.p_duration}</td>
                                    <td className="text-center align-middle">{s3?.p_duration}</td>
                                </>
                                : <>
                                    <td className="text-center align-middle">{totalDuration}{totalDuration ? <Label data='LabelMinuteShort' /> : ''}</td>
                                    <td className="text-center align-middle">{s1?.p_duration}{s1?.p_duration ? <Label data='LabelMinuteShort' /> : ''}</td>
                                    <td className="text-center align-middle">{s2?.p_duration}{s2?.p_duration ? <Label data='LabelMinuteShort' /> : ''}</td>
                                    <td className="text-center align-middle">{s3?.p_duration}{s3?.p_duration ? <Label data='LabelMinuteShort' /> : ''}</td>
                                </>
                            }
                        </tr>
                    }

                </tbody>
            </table>
        </>
    )
    return scoreboard
}

const ResponsiveHeaders = ({ mirs_discipline, entity, code }) => {
    const { breakPoint } = useViewport()
    if (breakPoint === "sm" || breakPoint === "xs") {
        return (
            <>{code}</>

        )
    }
    else {
        return (
            <>
                <SportCode discipline={mirs_discipline} entity={entity} code={code} />
            </>
        )
    }

}

export default TeqScoreboard